import React from "react";
import PrimeProductInfo from "components/Product-Info-Pages/Prime/PrimeProductInfo";

const Prime = () => <PrimeProductInfo />;

export default Prime;
